<div class="modal__header">
    <div class="modal__header-actions header-actions--mobile">
        <button [attr.aria-label]="'modals.aria.closeDialog' | ibeadmin | async" (click)="INDRA_close()">
			<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'modals.alt.arrowLeftIcon' | ibeadmin | async"></app-svg>
		</button>
    </div>
    <div class="title_wrapper">
        <h2 class="title" id="modal__title">{{'bookingPayment.text.selectPaymentMethod' | ibeadmin | async}}</h2>
    </div>
    <div class="modal__header-actions header-actions">
        <button [attr.aria-label]="'modals.aria.closeDialog' | ibeadmin | async" (click)="INDRA_close()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'modals.alt.closeIcon' | ibeadmin | async"></app-svg>
		</button>
    </div>
</div>
 
<ng-container *ngIf="showLoading">
    <app-loading></app-loading>
</ng-container>

<div class="modal__body iframe-holder" *ngIf="urlSafe; else err">
    <iframe id="adyen-iframe" class="page-iframe" allowfullscreen frameBorder="0" [src]="urlSafe" (load)="onLoad()"></iframe>
 </div>
    
<ng-template #err>
    <div class="align-center top-gap bottom-gap" >
        {{ errMsg }}
    </div>
</ng-template>
